module.exports = __webpack_public_path__ + "img/ring_r_l_1_null@3x.b5dd1c03.png";